import React, { useEffect, useMemo, useState } from 'react';
import { Dropdown, ListGroup } from 'react-bootstrap';
import { Pin } from 'react-bootstrap-icons';
import TextInput from '../../form-generator/components/TextInput';
import { contactSearchPaths, contractSearchPaths, inventoryPaths } from '../../helpers/constants';
import { search } from '../../helpers/search';

const searchPaths = [
  ...inventoryPaths,
  ...contractSearchPaths.map(p => `contract/${p}`),
  ...contactSearchPaths.map(p => `contacts[]/${p}`)
];

const allSalesLocationObject = { _id: 'all', location: 'All' };

const InventoryList = ({ inventories = [], activeId = '', onSelect, appChoices, workspace = false }) => {
  const [query, setQuery] = useState('');
  const [filteredInventories, setFilteredInventories] = useState([]);
  const [selectedSaleLocation, setSelectedSaleLocation] = useState(allSalesLocationObject);

  const salesLocations = useMemo(
    () => [allSalesLocationObject, ...(appChoices.find(a => a.key === 'salesLocation')?.values || [])],
    [appChoices]
  );

  useEffect(() => {
    const unitsByLocation = inventories.filter(
      c =>
        selectedSaleLocation._id === 'all' || (c['unitLocation']?._id || c['unitLocation']) === selectedSaleLocation._id
    );

    setFilteredInventories(search(unitsByLocation, searchPaths, query, '_id'));
  }, [query, selectedSaleLocation, inventories]);

  return (
    <div className={workspace ? "inventory-workspace-list" : "px-2"}>
      <div className={"d-flex mb-2 " + (workspace ? "inventory-list-filters" : "")}>
        <div className="flex-grow-1 mr-1">
          <TextInput size="sm" hint={workspace ? "Filter loaded homes…" : "Quick search..."} onChange={e => setQuery(e.target.value)} />
        </div>
        <Dropdown>
          <Dropdown.Toggle size="sm" block variant="outline-primary" id={workspace ? "inventory-list-location" : "dropdown-basic"} aria-label="Filter inventory list by location">
            <Pin className="mr-3 align-text-bottom" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {salesLocations.map(s => (
              <Dropdown.Item
                className={`${s._id === selectedSaleLocation._id ? 'bg-primary text-white' : ''}`}
                onClick={() => setSelectedSaleLocation(s)}
                key={s._id}
              >
                {s.location}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <ListGroup>
        {filteredInventories.length > 0 ? (
          filteredInventories.map((c, i) => (
            <ListGroup.Item
              style={{ fontSize: 12 }}
              className={`py-1 text-${c['_id'] === activeId ? 'white' : 'dark'}`}
              key={c['_id']}
              action
              active={c['_id'] === activeId}
              onClick={() => onSelect && onSelect(c)}
            >
              {c['serialA'] || c['serialB'] || 'N/A'}
              {workspace && <span className="inventory-list-description">{[
                (typeof c.model === 'object' ? c.model : appChoices.find(choice => choice.key === 'model')?.values.find(model => model._id === c.model))?.modelName,
                (typeof c.unitLocation === 'object' ? c.unitLocation : salesLocations.find(location => location._id === c.unitLocation))?.location
              ].filter(Boolean).join(' · ') || c.inventoryStatus || 'Home details'}</span>}
            </ListGroup.Item>
          ))
        ) : (
          <h6 className="py-5 text-center border rounded smallFont">No inventories to show </h6>
        )}
      </ListGroup>
    </div>
  );
};

export default InventoryList;
